module.exports = __webpack_public_path__ + "img/ch62.b1c72f65.jpg";